import moment from "moment";

const getAllYears = () => {
  return Array.from(
    { length: 2099 - 1900 + 1 },
    (_, index) => 1900 + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getFutureYears = () => {
  return Array.from(
    { length: 2099 - new Date().getFullYear() + 1 },
    (_, index) => new Date().getFullYear() + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getPastYears = () => {
  return Array.from(
    { length: new Date().getFullYear() - 1900 + 1 },
    (_, index) => 1900 + index
  ).map((year) => ({ Key: year, Value: year }));
};

const getPastYearsDescending = () => {
  return Array.from(
    { length: new Date().getFullYear() - 1900 + 1 },
    (_, index) => 1900 + index
  )
    .reverse()
    .map((year) => ({ Key: year, Value: year }));
};

const formatDateValue = (value, format = "DD/MM/YYYY") => {
  if (!value) {
    return null;
  }

  const parsed = moment(value);

  return parsed.isValid()
    ? parsed.format(format)
    : String(value);
};

const getMillisecondsUntilNextQuarterHour = (now = new Date()) => {
  const next = new Date(now);
  const minutes = now.getMinutes();
  const nextQuarter = Math.floor(minutes / 15) * 15 + 15;

  if (nextQuarter >= 60) {
    next.setHours(now.getHours() + 1, 0, 0, 0);
  } else {
    next.setMinutes(nextQuarter, 0, 0);
  }

  return Math.max(next.getTime() - now.getTime(), 0);
};

export {
  formatDateValue,
  getAllYears,
  getFutureYears,
  getMillisecondsUntilNextQuarterHour,
  getPastYears,
  getPastYearsDescending,
};
